import { styled } from "@mui/material/styles";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { colors } from "../../../theme/theme";

export const RootWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));

export const IconImg = styled("img")({
  height: "70px",
  width: "70px",
});

export const ContentStack = styled(Stack)(({ theme }) => ({
  width: "100%",
  flexDirection: "row",
  justifyContent: "space-between",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    justifyContent: "center",
  },
}));

export const ContentColumn = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const ContentGapBox = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: 30,
  [theme.breakpoints.down("1150")]: {
    flexDirection: "column",
  },
}));

export const BackIconButton = styled(IconButton)({
  width: 50,
  height: 50,
  alignSelf: "center",
  "& .MuiSvgIcon-root": {
    fontSize: "22px",
    color: colors.primary,
    height: 35,
    width: 35,
  },
});

export const TitleText = styled(Typography)(({ theme }) => ({
  ...theme.heading,
  lineHeight: "44px",
  fontSize: "40px",
  alignSelf: "center",
  [theme.breakpoints.down("md")]: {
    fontSize: "32px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "26px",
  },
}));

export const BodyText = styled(Typography)(({ theme, active }) => ({
  ...theme.body,
  marginTop: theme.spacing(1),
  fontSize: "18px",
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
  color: active ? colors.calmBlue : colors.primary,
}));

export const VideoSection = styled(Box)(({ theme }) => ({
  cursor: "pointer",
  width: 300,
  justifyItems: "end",
  [theme.breakpoints.down("1150")]: {
    width: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    minWidth: 200,
    width: "auto",
  },
}));

export const VideoIframe = styled("iframe")(({ theme }) => ({
  border: "none",
  borderRadius: theme.spacing(2),
  width: 300,
  aspectRatio: "16/9",
  display: "block",
  [theme.breakpoints.down("1150")]: {
    width: "100%",
    maxWidth: "1000px",
    margin: "auto",
  },
  [theme.breakpoints.down("sm")]: {
    minWidth: 200,
    width: "auto",
  },
}));

export const VideoLinkText = styled(Typography)({
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: 600,
  fontSize: "14px",
  color: colors.calmBlue,
  textDecoration: "underline",
  marginTop: "20px",
});

export const VideoLinkSpan = styled(Typography)({
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: 500,
  fontSize: "14px",
  color: colors.primary,
  textAlign: "center",
});

export const LinkContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "10px",
  alignItems: "baseline",
  [theme.breakpoints.down("396")]: {
    alignItems: "center",
  },
}));

export const SessionToggleButton = styled("button")({
  margin: 0,
  padding: 0,
  border: "none",
  background: "none",
  cursor: "pointer",
  font: "inherit",
  color: "inherit",
  textAlign: "inherit",
  "&:focus-visible": {
    outline: `2px solid ${colors.calmBlue}`,
    outlineOffset: 2,
    borderRadius: 2,
  },
});
